import styled from "styled-components";

export const MobileChatListDrawerWrapper = styled.div<{ $isOpen?: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: ${(props) => (props.$isOpen ? "0" : "-100%")};
  z-index: 9998;
  width: 100%;
  background-color: ${(props) => props.theme.background.primary};
  padding: ${(props) => props.theme.spacing.large};
  transition: left 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
`;

export const MobileChatListDrawerBody = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MobileChatListDrawerClose = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 1rem;

  > span {
    > svg {
      height: 2rem;
      width: auto;
      color: #fff;
      cursor: pointer;
    }
  }
`;

export const MobileChatListHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const MobileChatListNewChatButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: #000000;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  margin: 0;

  &:hover {
    background-color: #333333;
  }

  > svg {
    flex-shrink: 0;
  }
`;

export const MobileChatListSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  min-height: 40px;

  svg {
    color: rgba(255, 255, 255, 0.7);
    flex-shrink: 0;
  }

  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 0.875rem;
    color: #ffffff;
    font-weight: 400;
    line-height: 1.5;
    padding: 0;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }
`;

export const MobileChatListContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0.5rem 0;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const MobileChatListItem = styled.div<{ $isActive?: boolean }>`
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  margin-bottom: 0.25rem;
  background-color: ${(props) => (props.$isActive ? "rgba(255, 255, 255, 0.15)" : "transparent")};
  line-height: 1.5;
  color: ${(props) => (props.$isActive ? "#ffffff" : "rgba(255, 255, 255, 0.8)")};

  &:hover {
    background-color: ${(props) =>
      props.$isActive
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(255, 255, 255, 0.1)"
    };
    color: #ffffff;
  }
`;

export const MobileChatListDateSeparator = styled.div`
  padding: 1rem 0.75rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

